export const auth = {
  storageTokenKeyName: "_tid",
  storageUserKeyName: "_u_data",
  storageRolePermissionKeyName: "role-permission"
};
